import React from 'react';
import { Grid, Box, Container } from '@mui/material';
import HeadingTitle from '../HeadingTitle';
import DashboardCard from './DashboardCard';
import InspectionCard from './InspectionCard';
import { useBuildings } from '../../reactQuery/building';
import { useHPDTickets } from '../../reactQuery/violations';
import { useLL55Compliance } from '../../reactQuery/ll55';
import { useLeadCompliance } from '../../reactQuery/leadCompliance';
import { isAdmin } from '../../utils/helpers';
import { useJobs } from '../../reactQuery/job';
import WeeklyReport from '../../pages/Client/detail/components/WeeklyReport';

const DashboardMetrics = ({clientId=null}) => {

  const user = JSON.parse(localStorage.getItem("userData"));
  // Data for Buildings card
    const {  totalRecords, isLoading } = useBuildings(clientId ? {clientId: clientId} : {});

  // Data for HPD Violations
    const {
      statusCounts: hpdStatusCounts,
    } = useHPDTickets(clientId ? {clientId: clientId} : {}, clientId);

  // Data for LL55
  const { statusCount: ll55StatusCount } = useLL55Compliance(
    `?year=${new Date().getFullYear()}${
      user.role === "client" || clientId ? "&client_id=" + clientId || user.role_id : ""
    }`, clientId
  );

  // Data for annual Compliance
   const { statusCount: annualComplianceStatusCount } = useLeadCompliance(
     `?page=1&page_size=10&year=${new Date().getFullYear()}${
       user.role === "client" || clientId ? "&client_id=" + clientId || user.role_id : ""
     }`, clientId
   );

   // Data for Tickets Jobs
     const {
       statusCounts: ticketsStatusCounts,
     } = useJobs({
       page:  1,
       pageSize:10, 
       pagination: true,
       ...(clientId ? {client: '&client_id=' + clientId} : {}),
     }, clientId);
  

  // Data for Annual Notices card
  const annualNoticesData = [
    { label: "Total", value: annualComplianceStatusCount?.total || 0 },
    { label: "Pending", value: annualComplianceStatusCount?.pending || 0 },
    { label: "No Action", value: annualComplianceStatusCount?.completed || 0 },
    {
      label: "Inspection Req",
      value: annualComplianceStatusCount?.inspection_needed || 0,
    },
    {
      label: "Window Guards Req",
      value: annualComplianceStatusCount?.windows_guards_required || 0,
    },
    {
      label: "Knob Covers Req",
      value: annualComplianceStatusCount?.knob_covers_required || 0,
    },
    { label: "Fire Req", value: annualComplianceStatusCount?.fire_safety_required_count || 0 },
  ];

  // Data for LL55 card
  const ll55Data = [
    { label: "Total", value: ll55StatusCount?.total || 0 },
    { label: "Pending", value: ll55StatusCount?.pending || 0 },
    { label: "No Action", value: ll55StatusCount?.no_action || 0 },
    { label: "Mold", value: ll55StatusCount?.mold_required || 0 },
    { label: "Roaches", value: ll55StatusCount?.roaches_required || 0 },
    { label: "Mice/Rats", value: ll55StatusCount?.mice_rats_required || 0 },
  ];

  // Data for Inspections card
  const inspectionsData = [
    {
      label: "Pending Tickets",
      value: ticketsStatusCounts?.pending_count || 0,
    },
    { label: "No Access", value: ticketsStatusCounts?.no_access_count || 0 },
    {
      label: "Recent Uploads",
      value: ticketsStatusCounts?.recent_uploads || 0,
    },
  ];

  // Data for HPD Violations card
  const hpdViolationsData = [
    { label: "Pending", value: hpdStatusCounts?.pending || 0 },
    { label: "Doc's Required", value: hpdStatusCounts?.docs_required || 0 },
    { label: "HPD Submitted", value: hpdStatusCounts?.submitted || 0 },
    {
      label: "Violations Removed",
      value: hpdStatusCounts?.vio_removed || 0,
    },
  ];

  const getProgress = (total, pending) => {
    if (total === 0) return 0; // Avoid divide by zero
    return Math.round(((total - pending) / total) * 100);
  };

  return (
    // <Container  disableGutters sx={{ mt: 4 }}>
    <Grid container spacing={2} sx={{ mt: 4 }}>
      <Grid container item spacing={2} xs={12} lg={6} md={6} mb={2}>
        <Grid item xs={12} lg={12} md={12} >
          <HeadingTitle
            title="Buildings"
            viewMoreLink={
              clientId && user.role == "admin" ? "buildings" : `/buildings`
            }
            showCount={isLoading ? "" : totalRecords || 0}
          />
        </Grid>
        <Grid item xs={12} lg={6} md={6} mb={2}>
          <HeadingTitle
            title="Annual Notices"
            viewMoreLink={`/lead-compliance?year=${new Date().getFullYear()}${
              clientId ? `&client=${clientId}` : ""
            }`}
          >
            <DashboardCard
              items={annualNoticesData}
              progress={getProgress(
                annualComplianceStatusCount?.total,
                annualComplianceStatusCount?.pending
              )}
              totalValue={annualComplianceStatusCount?.total}
            />
          </HeadingTitle>
        </Grid>

        <Grid item xs={12} lg={6} md={6} mb={2}>
          <HeadingTitle
            title="LL55"
            viewMoreLink={`/ll55?year=${new Date().getFullYear()}${
              clientId ? `&client=${clientId}` : ""
            }`}
          >
            <DashboardCard
              items={ll55Data}
              progress={getProgress(
                ll55StatusCount?.total,
                ll55StatusCount?.pending
              )}
              totalValue={ll55StatusCount?.total || 0}
              color="#4caf50"
            />
          </HeadingTitle>
        </Grid>
      </Grid>

      

      <Grid item  xs={12} lg={6} md={6} mb={2}>
        {clientId && user.role == "admin" && <Grid item xs={12} lg={12} md={12} mb={2}>
          <HeadingTitle
            title="Weekly Reports"
            download={<WeeklyReport />}
          />
        </Grid>}
        <Grid item xs={12} lg={12} md={12} mb={2}>
          <HeadingTitle
            title="Inspections: Lead XRF/Dustwipes"
            viewMoreLink={
              clientId
                ? `/client/${clientId}/inspections`
                : "/ticket?status=Pending"
            }
            color="#9c27b0"
          >
            <InspectionCard items={inspectionsData} />
          </HeadingTitle>
        </Grid>

        <Grid item xs={12} lg={12} md={12} mb={2}>
          <HeadingTitle
            title="HPD Violations"
            viewMoreLink="/hpd/violations"
            color="#f44336"
          >
            <InspectionCard items={hpdViolationsData} />
          </HeadingTitle>
        </Grid>
      </Grid>
    </Grid>
    // </Container>
  );
};

export default DashboardMetrics; 